// Timezone-proof calendar-date helpers.
//
// Lease-addendum dates (original lease date, effective date) are CALENDAR dates,
// not instants — they must read identically in every timezone. We therefore keep
// them as plain "YYYY-MM-DD" strings and never round-trip them through
// Date+toLocaleDateString (which shifts the day depending on the viewer's tz).

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/** Normalize any date-ish value to a "YYYY-MM-DD" string (tz-independent). */
export function toYmd(value) {
  if (!value) return "";
  if (typeof value === "string") {
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[1]}-${m[2]}-${m[3]}` : "";
  }
  const d = new Date(value);
  if (isNaN(d.getTime())) return "";
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
}

/** Format a date-only value as e.g. "July 1, 2026" — identical in every timezone. */
export function formatYmd(value, fallback = "—") {
  const ymd = toYmd(value);
  if (!ymd) return fallback;
  const [y, mo, da] = ymd.split("-");
  return `${MONTHS[Number(mo) - 1]} ${Number(da)}, ${y}`;
}
